// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fc15eadf","508":"851f1382"}[chunkId] + ".chunk.js";
};